import { useEffect } from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import {
  PlusOutlined,
  MinusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Empty, message, Spin } from "antd";
import { PageLoading } from "..";
import { IoMdAdd, IoMdCheckmark } from "react-icons/io";
const Index = (props) => {
  const { collect } = props;

  useEffect(() => {
    props?.request({ url: "/order/device/dropdown", model: "services" });
  }, []);

  const handleItem = (item) => {
    if (props?.collect?.service?.id === item?.id) {
      props?.setCollect({ ...collect, service: null });
    } else {
      props?.setCollect({ ...collect, service: item });
    }
  };

  const handleLink = (item) => {
    if (item?.link) {
      window?.open(item?.link, "_blank");
    }
  };

  const handleNext = () => {
    if (collect?.service?.id) {
      props?.setStep(props?.step + 1);
    } else {
      message.error("Үйлчилгээ сонгоно уу.");
    }
  };

  const handlePrev = () => {
    props?.setStep(props?.step - 1);
  };

  return (
    <div className="flex justify-center w-full">
      {props?.isservices === true ? <PageLoading /> : null}
      {props?.isservices === false && props?.resservices?.length === 0 ? (
        <div className="mt-5">
          <Empty imageStyle={{ height: 50 }} />
        </div>
      ) : null}

      <div className="flex flex-col gap-3 w-full lg:w-3/6">
        {props?.resservices?.map?.((item, i) => (
          <div
            key={i}
            className="border px-3 py-2 rounded-md flex justify-between items-center shadow shadow-md"
          >
            <div className="flex flex-col">
              <span className="font-bold">{item?.name}</span>
              <span className="text-xs">{item?.description}</span>
              <span className="text-xs text-primary font-bold">{`${item?.hour} цаг`}</span>
            </div>
            <div className="flex flex-col items-end justify-center">
              <Button
                type={collect?.service?.id === item?.id ? "primary" : ""}
                onClick={() => handleItem(item)}
                icon={
                  collect?.service?.id === item?.id ? (
                    <IoMdCheckmark size={16} />
                  ) : (
                    <IoMdAdd size={16} />
                  )
                }
              />
              <Button
                className="p-0 text-xs h-fit mt-2"
                type="link"
                onClick={() => handleLink(item)}
              >
                Танилцуулга
              </Button>
            </div>
          </div>
        ))}
        <div className="flex justify-between mt-2 lg:mt-5">
          <Button className="" onClick={handlePrev}>
            Буцах
          </Button>
          <Button type="primary" onClick={handleNext}>
            Үргэлжлүүлэх
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Index;
